import { AuthenticationContextType } from 'Foundation/Authentication';
import { FlyoutType } from './Utils/utils';
import { LoanInventoryTableFields } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtPortfolioLoansInventoryTable/types';
import { Dispatch, SetStateAction } from 'react';
import { ToastNotificationConfig } from '../../../HbtMasterPoolDetails/types';

export interface ForceStatusFlyoutProps {
  openFlyout: boolean;
  toggleDrawer: Function;
  loans?: string;
  loansData?: LoanInventoryTableFields[];
  masterPoolCmhcAccountNumber?: string;
  isFromLoansInventory?: boolean;
  radioButtonOptions?: [Option, Option];
  requestUrl?: string;
  typeOfFlyout?: FlyoutType;
  headerText?: string;
  loansToBeUpdatedTitle?: string;
  loansTypeToBeAdded?: string;
  textFieldPlaceholder?: string;
  textFieldButtonText?: string;
  addLoansDescription?: string;
  addLoansTextFieldError?: string;
  toasterHeader?: string;
  toasterDesc?: string;
  addLoansTextFieldErrorTwo?: string;
  remarksTextField?: string;
  remarksDropDownHeader?: RemarksDropDownHeader[];
  flyoutTitle?: string;
  successFlyoutDesc?: string;
  successFlyoutTitle?: string;
  copyButtonText?: string | VariableText;
  copiedButtonText?: string | VariableText;
  overrideModalDesc?: string;
  overrideModalTitle?: string;
  loansUpdateLargeFormFieldButtonText?: string;
  errorModalDesc?: string;
  errorModalHeader?: string;
  errorModalProceedText?: string;
  typeOfPortfolioInsurance?: PortfolioInsuranceType;
  callToaster?: (icon: string, message: string, desc?: string) => void;
  setMasterPoolNotification?: (show: boolean) => void;
  setNotificationBannerConfig?: Dispatch<SetStateAction<ToastNotificationConfig>>;
  setIsForceStatusTriggered?: (isTriggered: boolean) => void;
}

export interface VariableText {
  singular: string;
  plural: string;
}

export type PortfolioInsuranceType = 'validationReview' | 'masterPool';

export interface ValidationRemarkPayload {
  applicationId: number;
  cmhcAccountNumbers?: FlyoutStatusLoanData[];
  lenderReferenceNumbers?: FlyoutStatusLoanData[];
  poolprecitiontypecode: PoolProcessingStatusCode;
  portfolioIds: number[];
  targetStatus: PoolProcessingStatusCode | null;
  validateOnly: boolean;
  decisionOverrideRationaleId?: number;
  decisionOverrideRemarks?: string;
}
export interface MasterPoolRemarkPayload {
  loans: string[];
  targetStatus: PoolProcessingStatusCode | null;
  validateOnly: boolean;
  remark: {
    remarkId: number;
    remarkText: string;
  };
  isFromLoansInventory?: boolean;
  masterPoolCmhcAccountNumber?: string;
}
export interface MasterPoolRemarkResponse {
  cmhcAccountNumber: string;
  portfolioLoanAccountStatus: string;
  masterPoolCmhcAccountNumber: string;
  masterPoolAccountStatus: string;
  errorCode: string;
  lastRemark?: {
    remarkId: number;
    remarkText: string;
    rationaleEnglish: string;
    rationaleFrench: string;
  };
}

export interface ValidationRemarkResponse {
  cmhcAccountNumber?: FlyoutStatusLoanData;
  lenderReferenceNumber?: FlyoutStatusLoanData;
  status?: string;
  errorCode?: string;
  latestRemark?: {
    remarkId: number;
    remarkText: string;
    validationSequenceNumber: number;
    recordCreatedTimestamp: string;
    recordUpdatedTimestamp: string;
    recordUpdatedUserID: string;
    rationaleEnglish: string;
    rationaleFrench: string;
  };
}

export interface RemarksDropDownHeader {
  ids: number[];
  groupName: string;
}

type RequestPropsTableData = {
  authenticationContext: AuthenticationContextType;
  payload: getLoansStatusPayload;
};

type getLoansStatusPayload = {
  loans: string[];
  targetStatus: string;
  validateOnly: boolean;
};

export interface Option {
  value: string;
  label: React.ReactNode;
}
export interface Loan {
  id: string;
  accountNumber: string;
  validationReviewLoanData?: FlyoutStatusLoanData;
  status: string;
  hasError: boolean;
  errorCode?: string;
  isNew: boolean;
  lastRemark?: string;
}
export interface LoanStatusResponse {
  cmhcAccountNumber?: string;
  lenderReferenceNumber?: string;
  status?: string;
  portfolioLoanAccountStatus: string;
  masterPoolCmhcAccountNumber: string;
  masterPoolAccountStatus: string;
  errorCode?: string;
}
export interface RationaleOption {
  label: string;
  value: string;
  isGroup: boolean;
  groupName: string;
}

export enum PoolProcessingStatusCode {
  CANCELLED = '04',
  NON_CANCELLED = '01'
}

export interface FlyoutStatusLoanData {
  accountNumber: string;
  sequenceNumber: number | null;
}
